<template>
    <div class="fullHeight">
        <div class="d-flex justify-content-center align-items-center friendApprovalHeader">
            <div>
                <img border="0" :src="imgPath" width="45" height="45" alt="">
            </div>
        </div>
            <!-- <span class='logout_btn' v-on:click='onLogout'>{{ btnName }}</span>
        </div> -->
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <p>{{ this.message }}</p>
            </div>
            <div class="col-sm-12">
                <div class="row justify-content-center p-3" v-if="result">
                    <div class="btn nextBtn col-sm-3 mx-5 my-2" @click='friendApproval'>承認</div>
                    <div class="btn nextBtn col-sm-3 mx-5 my-2" @click='nonApproval'>申請を削除</div>
                </div>
            </div>
            <ConfirmDialog
                v-if="addDialog === true"
                :initialMessage="initialMessage"
                :doing="doing"
                :notDoing="notDoing"
                :processing="processing"
                @from-Dialog="fromDialog"
                @closeBtn="addOverlayHidden"
            />
        </Card>
    </div>
</template>

<script>
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import { CHECK_TMP_FRIEND_TOKEN,
         APPROVAL_GOLF_FRIEND,
         DELETE_TMP_GOLF_FRIEND } from '../../constants/golf_friend';
import { MEMBER_LOG_OUT } from "../../constants/signout";

export default {
    components: {
        Card,
        ConfirmDialog
    },
    data () {
        return {
            // ページタイトル
            page_title: 'お友達承認',
            // 会員番号
            member_no: '',
            // フルネーム
            full_name: '',
            // メッセージ
            message: '',
            // トークンの有効or無効
            result: true,
            // ダイアログの制御用
            addDialog: false,
            initialMessage: '',
            doing: '',
            notDoing: '閉じる',
            fromDialog: '',
            // エラーダイアログ表示フラグ
            showError: false,
            errorMessage: '',
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            btnName: '',
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            if (process.env.MIX_APP_URL) {
                this.btnName = 'アプリを起動';
            } else {
                this.btnName = 'ログアウト';
            }
            await this.checkToken();
        },
        async checkToken(){
            await this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: CHECK_TMP_FRIEND_TOKEN,
                variables: {
                    token: this.$route.query.token,
                    id: this.$route.query.id,
                    member_no: this.member_no
                }
            }).then(res => {
                if (res.data.checkTmpFriendToken.resultCode === 1) {
                    // 正常終了
                    if (res.data.checkTmpFriendToken.message) {
                        this.result = true;
                        this.message = res.data.checkTmpFriendToken.message + 'さんから';
                    } else {
                        this.result = true;
                        this.message = '';
                    }
                    this.message = this.message + 'お友達申請が届いております。承認しますか？';
                } else {
                    // 異常終了
                    this.result = false;
                    this.message = res.data.checkTmpFriendToken.message;
                }
            })
        },
        /** ----------------------------------------------
         * 同伴者登録ボタン処理
         * ---------------------------------------------- */
        friendApproval () {
            this.initialMessage = '承認しますか？';
            this.doing = '承認';
            this.fromDialog = this.registFriend;
            this.addDialog = !this.addDialog;
        },
        nonApproval () {
            this.initialMessage = '申請を削除しますか？';
            this.doing = '削除';
            this.fromDialog = this.deleteTmpData;
            this.addDialog = !this.addDialog;
        },
        registFriend () {
            this.$set(this.processing, 'btnDisabled', 1);
            this.$apollo.mutate({
                mutation: APPROVAL_GOLF_FRIEND,
                variables: {
                    token: this.$route.query.token,
                    id: this.$route.query.id,
                    member_no: this.member_no
                }
            }).then(res => {
                this.addDialog = !this.addDialog;
                this.result = false;
                this.message = '承認完了しました。';
                this.$set(this.processing, 'btnDisabled', 0);
            }).catch(error => {
                this.addDialog = !this.addDialog;
                this.result = false;
                this.message = '登録に失敗しました。';
                this.$set(this.processing, 'btnDisabled', 0);
            });
        },
        deleteTmpData () {
            this.$set(this.processing, 'btnDisabled', 1);
            this.$apollo.mutate({
                mutation: DELETE_TMP_GOLF_FRIEND,
                variables: {
                    token: this.$route.query.token
                }
            }).then(res => {
                this.addDialog = !this.addDialog;
                this.result = false;
                this.message = 'お友達申請は削除されました。';
                this.$set(this.processing, 'btnDisabled', 0);
            }).catch(error => {
                this.addDialog = !this.addDialog;
                this.result = false;
                this.message = '登録に失敗しました。';
                this.$set(this.processing, 'btnDisabled', 0);
            });
        },
        /** ----------------------------------------------
         * ダイアログ
         * ---------------------------------------------- */
        addOverlayHidden (data) {
          this.addDialog = !this.addDialog;
          this.$set(this.processing, 'result', '');
        },
        /** ----------------------------------------------
         * ログオフ処理
         * ---------------------------------------------- */
        onLogout () {
            this.$store.commit("loading/setIsLoading", true);

            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.mutate({
                mutation: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$store.commit("loading/setIsLoading", false);
                if (process.env.MIX_APP_URL) {
                    window.location.href = process.env.MIX_APP_URL;
                } else {
                    this.$router.push("/");
                }
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
    }
}

</script>

<style scoped>
.tops_body__header {
    height: 60px;
}
</style>
